import type { BlockerState, BoardState } from '../../../game/boardMVC/types';
import { filterUnique } from '../../../utils/array-utils';

export function boardsHaveSimilarBlockers(a: BoardState, b: BoardState, threshold: number): boolean {
  const aCounts = getBlockerCounts(a.blockers);
  const bCounts = getBlockerCounts(b.blockers);
  const keys = filterUnique([...Array.from(aCounts.keys()), ...Array.from(bCounts.keys())]);

  return !keys.some((key) => Math.abs((aCounts.get(key) ?? 0) - (bCounts.get(key) ?? 0)) > threshold);
}

function getBlockerCounts(blockerStates: (BlockerState & { hp?: number; score?: number })[] = []): Map<string, number> {
  const blockerCounts = new Map<string, number>();

  blockerStates.forEach((blocker) => {
    const blockerKey = getBlockerKey(blocker);
    const blockerCount = (blockerCounts.get(blockerKey) ?? 0) + 1;
    blockerCounts.set(blockerKey, blockerCount);
  });
  return blockerCounts;
}

function getBlockerKey(blocker: BlockerState & { hp?: number; score?: number }): string {
  return `${blocker.type}${blocker.hp !== undefined ? `, hp:${blocker.hp}` : ''}${blocker.score !== undefined ? `, score:${blocker.score}` : ''}`;
}
